import FullWidthBanner from "./_components/full-width-banner";

export default FullWidthBanner;
